import { useSyncExternalStore } from 'react';
import { Group, Modal, Stack, Text, getDefaultZIndex } from '@mantine/core';
import { Btn } from '@/components/ri/Btn';
import { useAuth } from '@/hooks/useAuth';
import {
  getSessionExpiredSnapshot,
  rememberSessionExpired,
  subscribeSessionExpiry,
} from '@/lib/sessionExpiry';

const noop = () => {};

export function SessionExpiredModal() {
  const expired = useSyncExternalStore(subscribeSessionExpiry, getSessionExpiredSnapshot);
  const { login } = useAuth();

  const signInAgain = () => {
    rememberSessionExpired();
    login();
  };

  return (
    <Modal
      opened={expired}
      onClose={noop}
      title="You've been signed out"
      withCloseButton={false}
      closeOnClickOutside={false}
      closeOnEscape={false}
      centered
      size="sm"
      radius="md"
      zIndex={getDefaultZIndex('max')}
      styles={{
        title: { fontWeight: 600, color: 'var(--text-primary)' },
        content: { background: 'var(--surface-raised)' },
        header: { background: 'var(--surface-raised)' },
      }}
    >
      <Stack gap="lg">
        <Text size="sm" c="var(--text-secondary)">
          Your session expired. Sign in again to pick up where you left off.
        </Text>
        <Group justify="flex-end">
          <Btn variant="primary" onClick={signInAgain} data-autofocus>
            Sign in again
          </Btn>
        </Group>
      </Stack>
    </Modal>
  );
}
